import React from 'react'
import TextLink from '~/components/atoms/TextLink'
import Button from '~/components/atoms/Button'
import ButtonArrow from '~/components/atoms/ButtonArrow'
import Image from '~/components/atoms/Image'
import FadeInWhenVisible from '~/components/FadeInWhenVisible'
import { StaticImage } from 'gatsby-plugin-image';
import './custom-reviews-banner.css';

export default function TextCard({
  className = '',
  innerClassName = '',
  buttonContainerClassName = '',
  illustration,
  heading,
  headingClassName = '',
  subheading,
  subheadingColor,
  subheadingClassName = '',
  content,
  buttons,
  alignText = 'left',
  image = false,
  differentextAndTitle = false,
  contentDesign = '',
  showTrustpilot = false
}) {

  const headingType = heading?.type
  const HeadingTag = headingType && headingType.substr(0, 1) === "h" ? headingType : "h2";

  if (!illustration && !heading?.text && !subheading && !content && !buttons) {
    return null
  }

  return (
    <div className={`space-y-6 ${className} text-${alignText}`}>
      <div className={`space-y-4 ${innerClassName}`}>
        {illustration && (
          <FadeInWhenVisible>
            <Image
              data={illustration}
              className={`${image ? 'hidden' : ''} h-44 w-44 ${alignText === 'center' ? 'mx-auto' : ''}`}
              objectFit="contain"
              objectPosition="center"
            />
          </FadeInWhenVisible>
        )}

        {subheading && (
          <FadeInWhenVisible transition={{ delay: '.05' }}>
            <h6
              className={`text-h6 ${(subheadingColor === 'Blue') ? 'text-blue' : 'text-navy text-opacity-50'} ${subheadingClassName}`}
            >
              {subheading}
            </h6>
          </FadeInWhenVisible>
        )}

        {heading && heading.text && HeadingTag && (
          HeadingTag === 'h1' ? (
            <HeadingTag
              className={`text-${differentextAndTitle ? 'h4' : headingType} text-${alignText} ${headingClassName}`}
            >
              {heading.text}
            </HeadingTag>
          ) : (
            <FadeInWhenVisible transition={{ delay: '.1' }}>
              <HeadingTag
                className={`text-${differentextAndTitle ? 'h4' : headingType} text-${alignText} ${headingClassName}`}
              >
                {heading.text}
              </HeadingTag>
            </FadeInWhenVisible>
          )
        )}

        {content && (
          <FadeInWhenVisible transition={{ delay: '.15' }}>
            <div
              className={`text-body-large prose ${differentextAndTitle ? 'text-base' : ''} ${contentDesign}`}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </FadeInWhenVisible>
        )}

        {showTrustpilot && (
          <div
            className="trustpilot-bar"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "14px",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                color: "#12203A",
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
                fontFamily: "Untitled Sans"
              }}
            >
              <span style={{ fontWeight: 500 }}>4.9/5</span>
              <span style={{ fontWeight: 400, marginLeft: "4px" }}>
                (2,000+ reviews)
              </span>
            </div>

            <div
              dangerouslySetInnerHTML={{
                __html: `
          <div>
            <div style="transform-origin: left center;">
              <div>
                <svg width="86" height="45" viewBox="0 0 86 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.3" d="M0.000976562 28.4551H16.1256V44.5797H0.000976562V28.4551ZM17.4693 28.4551H33.594V44.5797H17.4693V28.4551ZM34.9377 28.4551H51.0623V44.5797H34.9377V28.4551ZM52.406 28.4551H68.5306V44.5797H52.406V28.4551ZM69.8744 28.4551H85.999V44.5797H69.8744V28.4551Z" fill="#00B67A"/>
                  <path d="M0.000976562 28.4551H16.1256V44.5797H0.000976562V28.4551ZM17.4693 28.4551H33.594V44.5797H17.4693V28.4551ZM34.9377 28.4551H51.0623V44.5797H34.9377V28.4551ZM52.406 28.4551H68.5306V44.5797H52.406V28.4551ZM69.8744 28.4551H83.1002V44.5797H69.8744V28.4551Z" fill="#00B67A"/>
                  <path d="M8.06354 39.3223L10.5158 38.7009L11.5404 41.8586L8.06354 39.3223ZM13.7072 35.2408H9.39046L8.06354 31.176L6.73662 35.2408H2.41992L5.91359 37.7602L4.58667 41.825L8.08034 39.3055L10.2303 37.7602L13.7072 35.2408ZM25.5319 39.3223L27.9842 38.7009L29.0088 41.8586L25.5319 39.3223ZM31.1755 35.2408H26.8588L25.5319 31.176L24.205 35.2408H19.8883L23.3819 37.7602L22.055 41.825L25.5487 39.3055L27.6986 37.7602L31.1755 35.2408ZM43.0002 39.3223L45.4525 38.7009L46.4771 41.8586L43.0002 39.3223ZM48.6439 35.2408H44.3272L43.0002 31.176L41.6733 35.2408H37.3566L40.8503 37.7602L39.5234 41.825L43.017 39.3055L45.167 37.7602L48.6439 35.2408ZM60.4686 39.3223L62.9209 38.7009L63.9455 41.8586L60.4686 39.3223ZM66.1122 35.2408H61.7955L60.4686 31.176L59.1417 35.2408H54.825L58.3186 37.7602L56.9917 41.825L60.4854 39.3055L62.6353 37.7602L66.1122 35.2408ZM77.9369 39.3223L80.3892 38.7009L81.4138 41.8586L77.9369 39.3223ZM83.5806 35.2408H79.2639L77.9369 31.176L76.61 35.2408H72.2933L75.787 37.7602L74.4601 41.825L77.9537 39.3055L80.1037 37.7602L83.5806 35.2408Z" fill="#12203A"/>
                </svg>
              </div>
            </div>
          </div>
        `,
              }}
            />

            <div
              style={{
                minWidth: "90px",
              }}
              dangerouslySetInnerHTML={{
                __html: `
          <div>
            <div>
              <div>
                <!-- keep your existing second SVG/image block here exactly as it already is -->
              </div>
            </div>
          </div>
        `,
              }}
            />
          </div>
        )}
      </div>

      {buttons && (
        <div className={`flex flex-wrap gap-4 ${alignText === 'center' ? 'justify-center' : ''} ${buttonContainerClassName}`}>
          {buttons.map((buttonData, index) => {
            if (buttonData?.type === 'textLink' && buttonData?.button?.button) {
              return (
                <TextLink key={index} {...buttonData.button.button} />
              )
            }

            if (buttonData?.type === 'button' && buttonData?.button?.button) {
              return (
                <Button key={index} {...buttonData.button.button} />
              )
            }

            if (buttonData?.type === 'buttonArrow' && buttonData?.button?.button) {
              return (
                <ButtonArrow key={index} {...buttonData.button.button} />
              )
            }

            return null
          })}
        </div>
      )}
    </div>
  )
}